import * as React from 'react';
import { UIText2 } from '@cian/ui-kit/typography';
import { IconMapCar16, IconMapWalk16 } from '@cian/ui-kit-design-tokens/icons';

import * as styles from './FromUndergroundTime.css';

interface IFromUndergroundProps {
  timeTransport?: number | null;
  timeWalk?: number | null;
}

export const FromUndergroundTime: React.FC<IFromUndergroundProps> = props => {
  const { timeTransport, timeWalk } = props;

  if (timeWalk && timeWalk <= 20) {
    return (
      <>
        <div className={styles['icon']}>
          <IconMapWalk16 color={'icon-secondary-default'} />
        </div>
        <UIText2 color={'gray60_100'}>{timeWalk} мин.</UIText2>
      </>
    );
  }
  if (timeTransport) {
    return (
      <>
        <div className={styles['icon']}>
          <IconMapCar16 color={'icon-secondary-default'} />
        </div>
        <UIText2 color={'gray60_100'}>{timeTransport} мин.</UIText2>
      </>
    );
  }

  return null;
};
